let routes = [
  {
    path: '',
    component: resolve => require(['@/views/layout/Layout'], resolve),
    children: [
      {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/views/home/index'], resolve),
        meta: {
          title: '首页概览',
          breadLevel: 0,
          icon: 'icon-home'
        }
      },
      {
        path: '/subscribeBlock',
        name: 'subscribeBlock',
        component: resolve => require(['@/views/home/subscribe/list'], resolve),
        meta: {
          title: '订阅区块链列表',
          breadLevel: 1
        }
      },
      {
        path: '/blockInfo',
        name: 'blockInfo',
        component: resolve => require(['@/views/home/block/list'], resolve),
        meta: {
          title: '区块信息',
          breadLevel: 1
        }
      },
      {
        path: '/blockInfo/blockDetail',
        name: 'blockDetail',
        component: resolve => require(['@/views/home/block/blockDetail'], resolve),
        meta: {
          title: '区块详情',
          breadLevel: 2
        }
      },
      {
        path: '/transactionInfo',
        name: 'transactionInfo',
        component: resolve => require(['@/views/home/transaction/list'], resolve),
        meta: {
          title: '交易信息',
          breadLevel: 1
        }
      },
      {
        path: '/transactionInfo/txnDetail',
        name: 'txnDetail',
        component: resolve => require(['@/views/home/transaction/txnDetail'], resolve),
        meta: {
          title: '交易详情',
          breadLevel: 2
        }
      },
      {
        path: '/contractInfo',
        name: 'contractInfo',
        component: resolve => require(['@/views/home/contract/list'], resolve),
        meta: {
          title: '合约信息',
          breadLevel: 1
        }
      },
      {
        path: '/contractInfo/contractDetail',
        name: 'contractDetail',
        component: resolve => require(['@/views/home/contract/contractDetail'], resolve),
        meta: {
          title: '合约详情',
          breadLevel: 2
        }
      },
      {
        path: '/organizationInfo',
        name: 'organizationInfo',
        component: resolve => require(['@/views/home/organization/index'], resolve),
        meta: {
          title: '组织信息',
          breadLevel: 1
        }
      },
      {
        path: '/nodeInfo',
        name: 'nodeInfo',
        component: resolve => require(['@/views/home/node/index'], resolve),
        meta: {
          title: '节点信息',
          breadLevel: 1
        }
      }
    ]
  }
]

export default routes
